import { useState } from "react";
import styleds from "./styles";

function App() {

  const [isAtivo, setisAtivo] = useState(false)

  const handleClick = () => {
    setisAtivo(true)
  }

  return (
    <styleds.Main>
      <styleds.GlobalStyle />
      <styleds.Container>
        <styleds.Foto>
          <picture>
            <source media="(min-width: 828px)" srcSet="image-product-desktop.jpg" />
            <img src="image-product-mobile.jpg" alt="imagem do perfume 'Gabrielle Essence Eau De Parfum'" />
          </picture>
        </styleds.Foto>
        <styleds.Descricao>
        <h1>perfume</h1>

        <h2>Gabrielle Essence Eau De Parfum</h2>

        <p>A floral, solar and voluptuous interpretation composed by Olivier Polge, Perfumer-Creator for the House of CHANEL.</p>

        <div className="container">
          <div className="price">
            <span>149.99</span>
            <span>169.99</span>
          </div>
          <button className={isAtivo ? 'active' : ''} onClick={handleClick} type="button">
            <span className="carrinho">🛒</span>
            Add to Cart
          </button>
        </div>

        </styleds.Descricao>
      </styleds.Container>
    </styleds.Main>
  );
}

export default App